
export default function buildExportQuery () {
  const dataQuery: any = {
    query: {
      columns: {
        name: 'cl.name',
        category_income: 'cl.category_income',
        category_profit: 'cl.category_profit',

        manager_name: 'empl.name',

        city_name: 'city.name',
        ptype_name: 'ptype.name',
        credit: 'cl.credit',
        payment_deferment_period_id: 'cl.payment_deferment_period_id',

        person_name: 'person.name',
        person_contact: 'person_contact.value',

        counterparty_name: 'counterparty.name',
        counterparty_inn: 'counterparty.inn',
        counterparty_kpp: 'counterparty.kpp',

        pont_address: 'pont.address'
      },
      columns_order: [
        'name',
        'category_income',
        'category_profit',

        'manager_name',

        'city_name',

        'person_name',
        'person_contact',

        'counterparty_name',
        'counterparty_inn',
        'counterparty_kpp',

        'pont_address'
      ],
      column_names: {
        name: 'Клиент',
        category_income: 'Категория выручки',
        category_profit: 'Категрия прибыли',

        manager_name: 'Менеджер',
        city_name: 'Город',
        ptype_name: 'Тип оплаты',
        credit: 'Дебиторский лимит',
        payment_deferment_period_id: 'Отсрочка',

        person_name: 'Контакт',
        person_contact: 'Значение контакта',

        counterparty_name: 'Контрагент',
        counterparty_inn: 'ИНН',
        counterparty_kpp: 'КПП',

        pont_address: 'Точки доставки'
      },
      from: 's:clients',
      from_as: 'cl',
      joins: [
        {
          join: 's:employees',
          type: 'left',
          as:   'empl',
          on: {
            $eq: ['cl.manager_id', 'empl.id']
          }
        },

        {
          join: 's:cities',
          type: 'left',
          as:   'city',
          on: {
            $eq: ['city.id', 'cl.city_id']
          }
        },

        {
          join: 's:payment_types',
          type: 'left',
          as:   'ptype',
          on: {
            $eq: ['ptype.id', 'cl.payment_type_id']
          }
        },

        {
          join: 's:counterparties',
          type: 'left',
          as:   'counterparty',
          on: {
            $eq: ['cl.id', 'counterparty.client_id']
          }
        },

        {
          join: 's:delivery_points',
          type: 'left',
          as:   'pont',
          on: {
            $eq: ['cl.id', 'pont.client_id']
          }
        },

        {
          join: 's:people',
          type: 'left',
          as:   'person',
          on: {
            $eq: ['cl.id', 'person.client_id']
          }
        },
        {
          join: 's:contacts',
          type: 'left',
          as:   'person_contact',
          on: {
            $eq: ['person_contact.target_id', 'person.id']
          }
        }
      ]
    },
    format: 'xlsx'
  };

  return dataQuery;
}